import { ReactNode, isValidElement } from 'react';
import { Stack, Typography } from '@mui/material';

export default function LabeledData({ label, value }: { label: string; value: ReactNode | string }) {
  return (
    <Stack direction="column" justifyContent="flex-start" spacing={0.3}>
      <Typography variant="inputLabel" color="text.muted">
        {label}:
      </Typography>
      <div>{isValidElement(value) ? value : <Typography variant="body2">{value}</Typography>}</div>
    </Stack>
  );
}
